import React from 'react';
import { scrollToElement } from '../utils/scrollToElement';
/**
 * Critical-path component (above the fold). Optimized for FCP/LCP ≤ 2s on
 * mobile:
 *  - No framer-motion in this file (Button replaced with a plain styled <button>).
 *  - Mobile order: TEXT first, image second — the H1 paints with a system-font
 *    fallback almost immediately and becomes the LCP candidate (instead of the
 *    heavier image). Desktop keeps the image on the right.
 *  - Hero image uses an aggressive small/low-q variant for mobile.
 */
export function Hero() {
  return <section className="relative min-h-[85vh] flex items-center pt-24 pb-12 overflow-hidden" data-id="element-110">
      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-111">
        {/* Text block — first on mobile so the H1 becomes the LCP element */}
        <div className="flex flex-col items-start z-10 lg:order-1" data-id="element-112">
          <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-6 block" data-id="element-113">
            Un nuevo capítulo en el bienestar femenino
          </span>

          <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl leading-[1.1] text-ink mb-6 md:mb-8" data-id="element-114">
            Recupera tu <em className="italic text-sand-dark" data-id="element-115">energía</em>,
            balance y <em className="italic text-sand-dark" data-id="element-116">claridad</em>.
          </h1>

          <p className="text-base md:text-xl text-ink-light font-light leading-relaxed mb-8 md:mb-10 max-w-md" data-id="element-117">
            El método del 1% respaldado por la ciencia para equilibrar tus
            hormonas de forma natural, sin dietas extremas ni agotamiento.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-6" data-id="element-118">
            <button type="button" onClick={() => scrollToElement('precio')} className="inline-flex items-center justify-center bg-sand hover:bg-sand-dark text-white px-8 py-4 text-sm tracking-widest uppercase transition-colors duration-300 active:scale-[0.98]" data-id="element-119">
              Acceso Inmediato
            </button>
            <a href="#method" className="text-sm uppercase tracking-widest text-ink-light hover:text-ink transition-colors border-b border-transparent hover:border-ink pb-1" data-id="element-120">
              Descubre el Método
            </a>
          </div>
        </div>

        {/* Image block — second on mobile (below text), right column on desktop */}
        <div className="relative h-[35vh] sm:h-[45vh] lg:h-[80vh] w-full lg:order-2" data-id="element-121">
          <img src="https://images.unsplash.com/photo-1545389336-cf090694435e?q=60&w=400&auto=format&fit=crop" srcSet="https://images.unsplash.com/photo-1545389336-cf090694435e?q=60&w=400&auto=format&fit=crop 400w, https://images.unsplash.com/photo-1545389336-cf090694435e?q=65&w=720&auto=format&fit=crop 720w, https://images.unsplash.com/photo-1545389336-cf090694435e?q=70&w=1100&auto=format&fit=crop 1100w" sizes="(max-width: 1024px) 100vw, 50vw" alt="Mujer serena en plena naturaleza, irradiando vitalidad y equilibrio hormonal" width={1200} height={1500}
        // @ts-expect-error fetchpriority is valid HTML but typed loosely in React
        fetchpriority="high" loading="eager" decoding="async" className="relative w-full h-full object-cover rounded-t-full lg:rounded-t-[200px] lg:rounded-b-none shadow-soft-lg bg-sage/20" data-id="element-122" />
        </div>
      </div>
    </section>;
}